export default class BankStatementsFilter {
    public companyId: number | null = null;

    public year: string | null = null;
}